export class PatchOperationPimsModel {
  public operationId!: number;
  public name!: string;
  public active!: boolean;
}
